export enum EResourceType {
  Specialist = 'Specialist',
  Device = 'Device',
  Surgeon = 'Surgeon',
}

export enum ResourceRegionType {
  East = 'east',
  West = 'west',
  North = 'north',
  South = 'south',
}
